<nz-card nzTitle="Knowledge Graph Visualization">
  <button nz-button *ngIf="hasData==true && detailDownload!=true" nzBlock="true" nzType="primary" (click)="downloadChartData()">Download</button>
  <nz-empty *ngIf="!hasData"></nz-empty>
  <nz-spin nzSimple="true" *ngIf="loading == true"></nz-spin>
  <div *ngIf="hasData" echarts [options]="options" class="kg-chart" [autoResize]="'true'" (chartClick)="onChartEvent($event)"></div>
</nz-card>

<nz-drawer
      [nzBodyStyle]="{ height: 'calc(100% - 55px)', overflow: 'auto', 'padding-bottom': '53px' }"
      [nzMaskClosable]="true"
      [nzWidth]="500"
      [nzVisible]="visible"
      nzTitle="{{detailTitle}} Detail"
      (nzOnClose)="onClose()"
    >

    <nz-list nzItemLayout="horizontal">
      <nz-list-item *ngFor="let key of objectKeys">
        <nz-list-item-meta
          nzDescription="{{key}}"
        >
          <nz-list-item-meta-title>
            <p style="word-wrap: break-word; word-break: break-all;">{{ showData[key] }}</p>
          </nz-list-item-meta-title>
        </nz-list-item-meta>
      </nz-list-item>
      <nz-spin nzSimple="true" *ngIf="objectKeys == null"></nz-spin>
    </nz-list>
    
    <br />

    <!--<button nz-button nzBlock="true" nzType="primary">Detail</button>-->


    <button nz-button></button>
</nz-drawer>